import { useMemo } from 'react';

import { useSearchParams } from 'react-router-dom';

const useSearchData = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const defaultSearchData = {
    limit: 10,
    page: 1,
    search: '',
    assigneeType: '',
    estimationType: '',
    durationType: '',
    actionType: '',
    status: 'true',
  };

  const getString = (key, fallback = '') => searchParams.get(key) ?? fallback;

  const getNumber = (key, fallback) => {
    const val = searchParams.get(key);
    return val !== null ? Number(val) : fallback;
  };

  const searchData = useMemo(
    () => ({
      limit: getNumber('limit', defaultSearchData.limit),
      page: getNumber('page', defaultSearchData.page),
      search: getString('search', defaultSearchData.search),
      assigneeType: getString('assigneeType', defaultSearchData.assigneeType),
      estimationType: getString('estimationType', defaultSearchData.estimationType),
      durationType: getString('durationType', defaultSearchData.durationType),
      actionType: getString('actionType', defaultSearchData.actionType),
      status: getString('status', defaultSearchData.status),
    }),
    [searchParams]
  );

  const setSearchData = (updated) => {
    const nextParams = new URLSearchParams(searchParams);
    const fullSearchData = { ...searchData, ...updated };

    Object.entries(fullSearchData).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        nextParams.set(key, String(value));
      } else {
        nextParams.delete(key);
      }
    });

    setSearchParams(nextParams, { replace: true });
  };

  const resetSearchData = () => {
    const nextParams = new URLSearchParams();
    Object.entries(defaultSearchData).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        nextParams.set(key, String(value));
      }
    });
    setSearchParams(nextParams, { replace: true });
  };

  return {
    searchData,
    setSearchData,
    resetSearchData,
    defaultSearchData,
  };
};

export default useSearchData;
